module.exports = __webpack_public_path__ + "img/電気回路_4_9_4.30414fd7.png";